import { AntiSocialBehaviour } from './AntiSocialBehaviour';
import { CrimesAgainstStaff } from './CrimesAgainstStaff';
import { HateCrimes } from './HateCrimes';
import { InspectorsNoticeBoard } from './InspectorsNoticeBoard';
import { MentalHealthIncidents } from './MentalHealthIncidents';
import { MissingPersons } from './MissingPersons';
import { Objectives } from './Objectives';
import { OldOccurrences } from './OldOccurrences';
import { Placeholder } from './Placeholder';
import { PriorityIntelligence } from './PriorityIntelligence';
import { Prisoners } from './Prisoners';
import { SexualOffences } from './SexualOffences';
import { Subjects } from './Subjects';
import { SuddenDeaths } from './SuddenDeaths';
import { Teams } from './Teams';
import { UrgentActions } from './UrgentActions';
import { Vehicles } from './Vehicles';
import { VulnerableIncidents } from './VulnerableIncidents';
import { Watches } from './Watches';

export function Section({ id, ...props }) {
  switch (id) {
    case 'teams':
      return <Teams {...props} />;
    case 'vehicles':
      return <Vehicles {...props} />;
    case 'inspectorsNoticeBoard':
      return <InspectorsNoticeBoard {...props} />;
    case 'urgentActions':
      return <UrgentActions {...props} />;
    case 'missingPersons':
      return <MissingPersons {...props} />;
    case 'priorityIntelligence':
      return <PriorityIntelligence {...props} />;
    case 'watches':
      return <Watches {...props} />;
    case 'subjects':
      return <Subjects {...props} />;
    case 'prisoners':
      return <Prisoners {...props} />;
    case 'objectives':
      return <Objectives id={id} {...props} />;
    case 'antiSocialBehaviour':
      return <AntiSocialBehaviour id={id} {...props} />;
    case 'sexualOffences':
      return <SexualOffences id={id} {...props} />;
    case 'vulnerable':
      return <VulnerableIncidents id={id} {...props} />;
    case 'suddenDeaths':
      return <SuddenDeaths id={id} {...props} />;
    case 'mentalHealthIncidents':
      return <MentalHealthIncidents id={id} {...props} />;
    case 'crimesAgainstStaff':
      return <CrimesAgainstStaff id={id} {...props} />;
    case 'hateCrimes':
      return <HateCrimes id={id} {...props} />;
    case 'oldOccurrences':
      return <OldOccurrences id={id} {...props} />;
    case 'arrests':
    case 'burglaries':
    case 'violentCrimes':
    case 'bailChecks':
    case 'returns':
    case 'firearmsIncidents':
    case 'pursuits':
    case 'seriousCollisions':
    case 'domesticAbuseStalkingHarassment':
    case 'repeatVictims':
    case 'useOfForceOutstanding':
    case 'liveCaseFiles':
    default:
      return <Placeholder id={id} {...props} />;
  }
}
